// extracted by mini-css-extract-plugin
export default {"buttonbox":"about_buttonbox__mLGtM","bounce":"about_bounce__lu2NE"};